import { BookingItemProps } from "apis";
import { lazy } from "react";

export const PageAdminBookingConfig = lazy(() => import("./Config"));
export const PageAdminBooking = lazy(() => import("./List"));
export const PageAdminBookingCreate = lazy(() => import("./Add"));
export const PageAdminBookingUpdate = lazy(() => import("./Edit"));

export interface FormBookingValuesProps extends BookingItemProps {
    // topicId?: number;
    // topicIds?: string[]
}
export interface FormSearchBookingValuesProps {
    q?: string;
    specialtyIds?: string[],
    userIds?: string[],
}